import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 본문·레거시 문서 본문(Bootstrap 클래스) 모두 태그·클래스로 스타일링 */
export const SupplierEvaluationRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& th.bg-info': { fontWeight: 600 },
  // 좁은 열 머리글이 영어일 때 단어 중간에서 끊기지 않게
  '& table th': { wordBreak: 'keep-all', overflowWrap: 'normal' },
}));
